import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import LanguageSelect from "components/ProjectNonSpecificComponents/Elements/LanguageSelect"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import SaveAdminConfigurationButton from "components/ProjectSpecificComponents/Elements/AdminForm/atoms/SaveAdminConfigurationButton"
import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"
import Logo from "../../../Global/atoms/Logo"
import ReconnectButton from "../../atoms/Buttons/ReConnectButton"
import SettingsButton from "../../atoms/Buttons/SettingsButton"
import SavePTKMConfigurationButton from "components/ProjectSpecificComponents/Elements/AdminForm/atoms/SavePTKMConfigurationButton"
import ConfigButton from "../../atoms/Buttons/ConfigButton"

interface Props {}

const NavBarDesktop = observer(({}: Props) => {
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const location = useLocation()

	return (
		<div className="flex flex-col w-screen fill-cter relative">
			<HyperDiv
				direction="row"
				className="fill-cter relative"
				style={{
					height: "60px",
					padding: "0 1.5rem",
					borderBottom: store.subNavElement
						? "1px solid var(--gray-c2)"
						: "2px solid var(--gray-c2)",
					backgroundColor: formStore.settingsData.personalize.colorHeader,
					overflow: "hidden",
				}}
				spacedBetween
				centeredY
			>
				<Logo />
				<HyperDiv direction="row" centeredY alignedRight spaceBetweenElems="1rem">
					<LanguageSelect />

					{/* Admin stuff for admin side */}
					{store.isInAdminSection && (
						<>
							<ConfigButton />
							<SettingsButton />
							<ReconnectButton />
						</>
					)}
					{location.pathname.includes(ROUTES.FORM_CONFIGURATION) && (
						<SaveAdminConfigurationButton />
					)}
					{location.pathname.includes(ROUTES.PTKM_CONFIGURATION) && <SavePTKMConfigurationButton />}
				</HyperDiv>
			</HyperDiv>
			{store.subNavElement && (
				<div
					style={{
						borderBottom: store.subNavElement ? "2px solid var(--gray-c2)" : "",
						height: 30,
					}}
					className="flex flex-row items-center bg-gray-200 w-screen overflow-hidden fill-cter text-center justify-center"
				>
					{store.subNavElement}
				</div>
			)}
		</div>
	)
})

export default NavBarDesktop
